var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"wrap":""}},[_vm._l((_vm.items),function(ref,idx){
var text = ref.text;
var value = ref.value;
return [_c('v-flex',{key:'t' + idx,staticClass:"text-end pa-3 grey lighten-4 primary--text",attrs:{"xs6":""}},[_c('b',[_vm._v(_vm._s(text))])]),_c('v-flex',{key:'v' + idx,staticClass:"pa-3",attrs:{"xs6":""}},[_vm._v(" "+_vm._s(value)+" ")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }